import * as action_types from '../actions/action_types';
import { console_log } from '../utils/helper';

var initialState = {
    hasAccess: false,
    uid: '',
    token: '',
    currentLang:''
};

export const WelcomeReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case action_types.HAS_ACCESS:
            return {
                ...state,
                hasAccess: action.data.success,
                uid: action.data.uid,
                token: action.data.token
            };
        case action_types.CHANGE_LANGUAGE:
            return {
                ...state,
                currentLang: action.data
            };
        case action_types.ADD_UID:
            return {
                ...state,
                uid: action.data.uid
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/WelcomeReducer.js